import { render, staticRenderFns } from "./ContestTemplate.vue?vue&type=template&id=2b948e91&scoped=true&"
import script from "./ContestTemplate.vue?vue&type=script&lang=ts&"
export * from "./ContestTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ContestTemplate.vue?vue&type=style&index=0&id=2b948e91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b948e91",
  null
  
)

export default component.exports